import { byLabel } from 'module/helpers/comparators/by-label';
import { TranslationKey, useTranslation } from 'module/hooks/use-translation';
import { SelectFilterOperationType } from 'module/types/filter-field/filter/select';
import { SingleSelectFieldFilter } from 'module/types/filter-field/filter/single-select';
import { SingleUserFieldFilter } from 'module/types/filter-field/filter/single-user';
import { getValue } from 'module/ui/components/molecules/field-filter/criteria/single-select-base';
import { snakeCase, startCase } from 'lodash';
import { FC } from 'react';
import styled from 'styled-components';
import { removeTrailingDots } from './utils';

const Text = styled.span`
  max-width: inherit;
  text-wrap: wrap;
`;

const getFilterValues = (
  filter: SingleSelectFieldFilter | SingleUserFieldFilter,
  options,
): string[] => {
  const { type } = filter;

  return type === SelectFilterOperationType.Is ||
    type === SelectFilterOperationType.IsNot ||
    type === SelectFilterOperationType.IsAtLeast ||
    type === SelectFilterOperationType.IsAtMost ||
    type === SelectFilterOperationType.IsOneOf ||
    type === SelectFilterOperationType.IsNoneOf
    ? getValue(filter)
        .map((x) => (options ?? []).find((u) => u?.value === x)!)
        .sort(byLabel)
        .map((x) => x?.label)
    : [];
};

export const SingleSelectBaseFilterToText: FC<
  React.PropsWithChildren<{
    filter: SingleSelectFieldFilter | SingleUserFieldFilter;
    options;
  }>
> = ({ filter, options }) => {
  const {
    field: { fieldLabel },
    type,
  } = filter;

  return (
    <Text>
      {startCase(fieldLabel)}{' '}
      {removeTrailingDots(
        useTranslation(
          `task_list.filters.${snakeCase(type)}` as TranslationKey,
        ),
      )}{' '}
      {getFilterValues(filter, options).join(', ')}
    </Text>
  );
};
